import { Loader2 } from "lucide-react";

const map = {
  pending: { label: "Queued", cls: "text-zinc-300 bg-zinc-800/60 border-zinc-700" },
  transcribing: { label: "Transcribing", cls: "text-blue-300 bg-blue-500/10 border-blue-500/20", spin: true },
  transcribed: { label: "Transcribed · needs scoring", cls: "text-cyan-300 bg-cyan-500/10 border-cyan-500/20" },
  scoring: { label: "Scoring", cls: "text-violet-300 bg-violet-500/10 border-violet-500/20", spin: true },
  done: { label: "Complete", cls: "text-emerald-300 bg-emerald-500/10 border-emerald-500/20" },
  error: { label: "Failed", cls: "text-rose-300 bg-rose-500/10 border-rose-500/20" },
};

export default function StatusBadge({ status }) {
  const s = map[status] || map.pending;
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-medium border ${s.cls}`}
      data-testid={`status-${status}`}
    >
      {s.spin && <Loader2 className="h-3 w-3 animate-spin" />}
      {s.label}
    </span>
  );
}
